// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  fetchGetAllDisciplineInfoPending: false,
  fetchGetAllDisciplineInfoError: null,
  fetchGetAllDisciplineInfoSuccess: null,
  fetchGetAllSecondListByIDs: null, //第二级分类
  fetchGetAllThirdListByIDs: null, //第三级分类
  DefaultCategoryListData: [
    { key: 0, Name: '全部' },
    { key: 1, Name: '录播' },
    { key: 2, Name: '直播' },
    { key: 3, Name: '面授' },
    { key: 4, Name: '混合' },
    { key: 5, Name: '其他' },
  ],
  fetchGetStuCourseListPending: false,
  fetchGetStuCourseListError: null,
  fetchGetStuCourseListSuccess: null, //课程列表
  fetchGetStuCourseListTotal: 0,
  fetchGetCourseAndPackageListSuccess: null,
  fetchGetCourseAndPackageListTotal: 0,
  fetchCourseDetailPending: false,
  fetchCourseDetailError: null,
  fetchCourseDetailSuccess: null, //课程详情
  fetchGetCouponCourseListSuccess: null, //优惠券适用范围
  GetCourseCouponData: null,
  fetchStudentShowCouponListSuccess: null, //优惠券列表
  fetchGetRecommendCoursePending: false,
  fetchGetRecommendCourseError: null,
  fetchGetRecommendCourseSuccess: null,
  fetchGetRelationCoursePending: false,
  fetchGetRelationCourseError: null,
  fetchGetRelationCourseSuccess: null,
  fetchGetCourseChapterPending: false,
  fetchGetCourseChapterError: null,
  fetchGetCourseChapterSuccess: null,
  fetchGetCourseChapterCount: 0,
  fetchGetIsOrderPending: false,
  fetchGetIsOrderError: null,
  fetchGetIsOrderSuccess: null,
  fetchGetCourseCommentPending: false,
  fetchGetCourseCommentError: null,
  fetchGetCourseCommentSuccess: null,
  fetchGetCourseCommentCount: 0,
  fetchUpdateThumpUpPending: false,
  fetchUpdateThumpUpError: null,
  fetchUpdateThumpUpSuccess: null,
  fetchAddCommentPending: false,
  fetchAddCommentError: null,
  fetchAddCommentSuccess: null,
  fetchGetCourseDocPending: false,
  fetchGetCourseDocError: null,
  fetchGetCourseDocSuccess: null,
  fetchAddCollectionPending: false,
  fetchAddCollectionError: null,
  fetchAddCollectionSuccess: null,
  fetchGetStuCoursePackListPending: false,
  fetchGetStuCoursePackListError: null,
  fetchGetStuCoursePackListSuccess: null,
  fetchGetStuCoursePackListTotal: 0,
  fetchCoursePackDetailPending: false,
  fetchCoursePackDetailError: null,
  fetchCoursePackDetailSuccess: null,
  fetchCoursePackDetailCourseCount: 0,
  fetchDirectOrderPending: false,
  fetchDirectOrderError: null,
  fetchUnifiedCreateOrderPending: false,
  fetchUnifiedCreateOrderError: null,
  fetchUnifiedCreateOrderSuccess: null,
  fetchGetWConfigurationPending: false,
  fetchGetWConfigurationError: null,
  fetchGetWConfigurationSuccess: null,
  fetchGetVideoPending: false,
  fetchGetVideoError: null,
  fetchGetVideoSuccess: null,
  fetchGetVideoTokenPending: false,
  fetchGetVideoTokenError: null,
  fetchGetVideoTokenSuccess: null,
  fetchAddAnswerPending: false,
  fetchAddAnswerError: null,
  fetchAddAnswerSuccess: null,
  fetchGetAnswerListPending: false,
  fetchGetAnswerListError: null,
  fetchSaveVideoLookPending: false,
  fetchSaveVideoLookError: null,
  fetchGetDisciplineInfoByCoursePending: false,
  fetchGetDisciplineInfoByCourseError: null,
  fetchGetDisciplineInfoByCourseSuccess: null,
  fetchInputToCookiesPending: false,
  fetchInputToCookiesError: null,
  fetchGetSetlistPending: false,
  fetchGetSetlistError: null,
  fetchGetSetlistSuccess: null,
  fetchGetHaveCourseListDisciplinePending: false,
  fetchGetHaveCourseListDisciplineError: null,
  fetchGetHaveCourseListDisciplineSuccess: null,
  fetchGetCourseAndPackageListPending: false,
  fetchGetCourseAndPackageListError: null,
  fetchStudentShowCouponListPending: false,
  fetchStudentShowCouponListError: null,
  fetchStudentGetCouponPending: false,
  fetchStudentGetCouponError: null,
  fetchGetCouponCourseListPending: false,
  fetchGetCouponCourseListError: null,
  fetchGetCourseCouponPending: false,
  fetchGetCourseCouponError: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/course/redux/initialState.js